import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { fundingSearchFollowers, updateSearchFollower } from './types';

import {
  requestFundingSearchFollowersSuccess,
  requestFundingSearchFollowersFailure,
  requestUpdateSearchFollowerSuccess,
  requestUpdateSearchFollowerFailure,
} from './reducer';

const logger = new Logger('Saga:FundingSearch:SearchFollowers');

export function* requestFundingSearchFollowersSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.search_followers.funding_search_followers', {
        fundingSearchId: action.fundingSearchId,
      }),
    );

    yield put(requestFundingSearchFollowersSuccess(action.fundingSearchId, response.data));
  } catch (error) {
    logger.error('Failed to request funding search followers with the following error', error);
    yield put(requestFundingSearchFollowersFailure(action.fundingSearchId, error));
  }
}

export function* requestUpdateSearchFollowerSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.search_followers.funding_search_follower_toggle', {
        fundingSearchId: action.fundingSearchId,
        userId: action.userId,
      }),
    );

    yield put(requestUpdateSearchFollowerSuccess(action.fundingSearchId, response.data));
  } catch (error) {
    logger.error('Failed to update search follower with the following error', error);
    yield put(requestUpdateSearchFollowerFailure(action.fundingSearchId, error));
  }
}

export default function* searchFollowersSaga() {
  return yield all([
    takeLatest(fundingSearchFollowers.request, requestFundingSearchFollowersSaga),
    takeLatest(updateSearchFollower.request, requestUpdateSearchFollowerSaga),
  ]);
}
